import { render, staticRenderFns } from "./VipLesson.vue?vue&type=template&id=c4db7402&scoped=true&"
import script from "./VipLesson.vue?vue&type=script&lang=js&"
export * from "./VipLesson.vue?vue&type=script&lang=js&"
import style0 from "./VipLesson.vue?vue&type=style&index=0&id=c4db7402&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4db7402",
  null
  
)

export default component.exports